import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { useTranslation } from "react-i18next"; // Importer useTranslation

const VisibilityButton = ({ isVisible, onClick, itemType }) => {
  const { t } = useTranslation(); // Assigner useTranslation à {t}

  const renderToolTip = (message) => (
    <Tooltip id="button-tooltip">{message}</Tooltip>
  );

  const getTooltipMessage = () => {
    if (itemType === "lesson") {
      return isVisible ? t("hide_lesson_tooltip") : t("show_lesson_tooltip");
    }
    if (itemType === "section") {
      return isVisible ? t("hide_section_tooltip") : t("show_section_tooltip");
    }
    return "";
  };

  return isVisible ? (
    <OverlayTrigger
      placement="top"
      overlay={renderToolTip(getTooltipMessage())}
    >
      <FaEye onClick={onClick} size={20} className="icon" />
    </OverlayTrigger>
  ) : (
    <OverlayTrigger
      placement="top"
      overlay={renderToolTip(getTooltipMessage())}
    >
      <FaEyeSlash onClick={onClick} size={20} className="icon" />
    </OverlayTrigger>
  );
};

export default VisibilityButton;
